import styled from 'styled-components';

export const Container = styled.div`
  color: #1b2a20;
  /* a foto subiu para a Capa: o bloco fica branco, com texto escuro */
  background-color: #fff;
  padding-bottom: 10rem;
  padding-top: 10rem;

`;

export const ContentBannersBox = styled.div`
  margin: 0 auto;
  width: 90%;
  max-width: 70.13rem;
  padding-bottom: 3rem;

  p,
  img {
    margin-bottom: 1.25rem;
    font-size: 1rem;
    text-align: justify;
  }
`;
